module.exports = __webpack_public_path__ + "img/maintenance-bg.c53e4774.jpg";